import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Category} from "../type/category";

@Component({
    selector: 'app-company-category-add',
    templateUrl: './company-category-add.component.html',
})
export class CompanyCategoryAddComponent implements OnInit {
    node = 'company-category';
    //companyCategory: Category = Category;
    companyCategories: [Category] = [Category];

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private location: Location
    ) {}



    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    onFormSubmit(formData) {
        var data = {
            company_category : formData.value.company_category,
            parent_id : formData.value.parent_id
        };
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Company Category added successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyCategories = [Category];
                } else {
                    this.companyCategories = response.json().data;
                }
            });
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/company-category/company-category-add.component.ts